import React from 'react';
import { withTranslation } from 'react-i18next';

import UserButtonBase from '../../Components/UserButton';
import getConfig from '../../Util/Config';

const getTranslation = (t) => {
  const { passportProviders } = getConfig().skooldioLogin || {};
  const providerBtnTranslation = passportProviders
    ? passportProviders.reduce((obj, passportProvider) => {
        const { provider, btnTransKey } = passportProvider;
        obj[`${provider}Btn`] = { label: t(btnTransKey) };
        return obj;
      }, {})
    : {};
  return {
    button: {
      logIn: t('USER_BUTTON.LOGIN'),
      register: t('USER_BUTTON.REGISTER'),
    },
    logInModal: {
      headline: {
        firstLine: t('LOGIN.HEADLINE.FIRST_LINE'),
        secondLine: t('LOGIN.HEADLINE.SECOND_LINE'),
      },
      form: {
        logInError: t('LOGIN.FORM.LOGIN_ERROR'),
        username: {
          label: t('LOGIN.FORM.USERNAME.LABEL'),
          placeholder: t('LOGIN.FORM.USERNAME.PLACEHOLDER'),
          error: t('LOGIN.FORM.USERNAME.ERROR'),
        },
        password: {
          label: t('LOGIN.FORM.PASSWORD.LABEL'),
          placeholder: t('LOGIN.FORM.PASSWORD.PLACEHOLDER'),
          error: t('LOGIN.FORM.PASSWORD.ERROR'),
        },
        rememberData: {
          label: t('LOGIN.FORM.REMEMBER_DATA.LABEL'),
        },
        submit: {
          label: t('LOGIN.FORM.SUBMIT.LABEL'),
        },
        ...providerBtnTranslation,
      },
      footer: {
        firstText: t('LOGIN.FOOTER.FIRST_TEXT'),
        secondText: t('LOGIN.FOOTER.SECOND_TEXT'),
        register: t('LOGIN.FOOTER.REGISTER'),
      },
    },
  };
};

const UserButton = ({ t, ...props }) => {
  return <UserButtonBase translation={getTranslation(t)} {...props} />;
};

export default withTranslation('registerLogin')(UserButton);
